import { createApp } from 'vue'
import Analytics from '../src/Components/Analytics/analytics.vue'
import { createPinia } from "pinia";
import './assets/analytics.scss';
import 'element-plus/dist/index.css';
// import './assets/main.scss';


const pinia = createPinia();
const analyticsApp = createApp(Analytics);
analyticsApp.use(pinia);


analyticsApp.mount('#fv-analytics')
